import { render, staticRenderFns } from "./arboviral_surveillance.vue?vue&type=template&id=744b9933&"
import script from "./arboviral_surveillance.vue?vue&type=script&lang=js&"
export * from "./arboviral_surveillance.vue?vue&type=script&lang=js&"
import style0 from "./arboviral_surveillance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports